import dayjs from "dayjs";

export const displayDateTimeCompact = (date: string | Date | undefined | null) => {
  if (!date) return '';
  date = new Date(date);

  return dayjs(date).format('DD MMM YYYY, HH:mm:ss');
};

export const displayDateTime = (date: string | Date | undefined | null) => {
  if (!date) return '';
  date = dayjs(date).toDate();

  const dateString = date.toLocaleString('id-ID', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  const timeString = date.toLocaleString('en-UK', {
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric'
  });

  return `${dateString}, ${timeString}`;
};

export const displayDate = (date: string | Date | undefined | null) => {
  if (!date) return '';
  date = new Date(date);

  return date.toLocaleString('id-ID', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};